<app-loader-circles *ngIf="showLoader"></app-loader-circles>
<div class="row content-container">
  <form [formGroup]="dadosClienteForm" class="forms">
    <div class="row info-container white-box">
      <h2>Informações do Cliente</h2>
      <div class="form-group">
        <span class="icon documento"></span>
        <div class="inputs">
          <div style="display: inline-flex">
            <label for="cpf">CPF</label>
            <div style="margin-top: -3px">
              <saiba-mais
                [isPopoverOnHover]="true"
                [isPositionStatic]="true"
                [isSmall]="true"
                [texto]="'Informe o CPF do cliente, contendo 11 números. Não é necessário inclusão de pontos ou traço.'"></saiba-mais>
            </div>
          </div>
          <input
            class="form-control"
            type="text"
            placeholder="000.000.000-00"
            required
            mask-number
            [mask]="'999.999.999-99'"
            inputmode="numeric"
            appCpfValidator
            appShowErrorMessages
            requiredMessage="O campo CPF é obrigatório"
            formControlName="cpf"
            name="cpf"
            (blur)="onCpfChange()">
        </div>
      </div>

      <div class="form-group">
        <span class="icon conjuge"></span>
        <div class="inputs">
          <div style="display: inline-flex">
            <label for="dataNascimento">Data de Nascimento</label>
            <div style="margin-top: -3px">
              <saiba-mais
                [isPopoverOnHover]="true"
                [isPositionStatic]="true"
                [isSmall]="true"
                [texto]="'Informe a data de nascimento do cliente, através de números do formato DD/MM/AAAA.'"></saiba-mais>
            </div>
          </div>
          <app-input-date

            requiredMessage="O campo Data de Nascimento é obrigatório"
            formControlName="dataNascimento"></app-input-date>
        </div>
      </div>

      <div class="form-group">
        <span class="icon classe-profissional"></span>
        <div class="inputs">
          <div style="display: inline-flex">
            <label for="classeProfissional">Classe Profissional</label>
            <div style="margin-top: -3px">
              <saiba-mais
                [isPopoverOnHover]="true"
                [isPositionStatic]="true"
                [isSmall]="true"
                [texto]="'Informe a classe profissional que o cliente possui.'"></saiba-mais>
            </div>
          </div>
          <select
            class="form-control"
            required
            appShowErrorMessages
            requiredMessage="O campo Classe Profissional é obrigatório"
            name="classeProfissional"
            formControlName="classeProfissional">
            <option value="" selected hidden>Selecione...</option>
            <option *ngFor="let classe of classesProfissionais" value="{{ classe.id }}">{{ classe.descricao }}</option>
          </select>
        </div>
      </div>
    </div>
  </form>
  <form [formGroup]="dadosConjugeForm" class="forms">
    <div class="row info-container blue-box" *ngIf="showConjugeSubject.value">
      <h2>Informações do Cônjuge</h2>

      <div class="form-group">
        <span class="icon documento"></span>
        <div class="inputs">
          <div style="display: inline-flex">
            <label for="cpfConjuge">CPF</label>
            <div style="margin-top: -3px">
              <saiba-mais
                [isPopoverOnHover]="true"
                [isPositionStatic]="true"
                [isSmall]="true"
                [texto]="'Informe o CPF do cônjuge, contendo 11 números. Não é necessário inclusão de pontos ou traço.'"></saiba-mais>
            </div>
          </div>
          <input
            class="form-control"
            type="text"
            placeholder="000.000.000-00"
            required
            mask-number
            [mask]="'999.999.999-99'"
            inputmode="numeric"
            appCpfValidator
            appShowErrorMessages
            requiredMessage="O campo CPF é obrigatório"
            formControlName="cpfConjuge"
            name="cpfConjuge">
          <div class="text-danger" *ngIf="cpfsIguais">o CPF do conjuge não pode ser o mesmo do cliente</div>
        </div>
      </div>
      <div class="form-group">
        <span class="icon conjuge"></span>
        <div class="inputs">
          <div style="display: inline-flex">
            <label for="dataNascimentoConjuge">Data de Nascimento</label>
            <div style="margin-top: -3px">
              <saiba-mais
                [isPopoverOnHover]="true"
                [isPositionStatic]="true"
                [isSmall]="true"
                [texto]="'Informe a data de nascimento do cliente, através de números do formato DD/MM/AAAA.'"></saiba-mais>
            </div>
          </div>
          <app-input-date
            required
            requiredMessage="O campo Data de Nascimento é obrigatório"
            formControlName="dataNascimentoConjuge"></app-input-date>
        </div>
      </div>
    </div>
  </form>
  <form [formGroup]="rendaForm" class="forms">
    <div class="row info-container white-box">
      <div id="renda-container" class="form-group">
        <span class="icon dinheiro"></span>
        <div class="inputs">
          <div style="display: inline-flex">
            <label for="renda">Renda</label>
            <div style="margin-top: -3px">
              <saiba-mais
                [isPopoverOnHover]="true"
                [isPositionStatic]="true"
                [isSmall]="true"
                [texto]="'Informe a renda que o cliente possui. Lembre-se que pode ser solicitado comprovação desta renda. ' +
                      'Para rendas não comprovadas, não esqueça de marcar o campo Renda Atribuída.'"></saiba-mais>
            </div>
          </div>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 00.000,00"
            required
            maxlength="17"
            appShowErrorMessages
            requiredMessage="O campo Renda é obrigatório"
            formControlName="renda"
            name="renda"
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appMoedaValidator
            appOnlyNumberRestrictive
            valorMinimo=0>
        </div>
      </div>
    </div>
    <div class="row info-container white-box">
      <h2>Valores</h2>
      <div class="form-group">
        <span class="icon dinheiro"></span>
        <div class="inputs">
          <div style="display: inline-flex">
            <label for="valorSolicitado">Valor Solicitado</label>
            <div style="margin-top: -3px">
              <saiba-mais
                [isPopoverOnHover]="true"
                [isPositionStatic]="true"
                [isSmall]="true"
                [texto]="'Informe o valor do financiamento solicitado.'">
              </saiba-mais>
            </div>
          </div>
          <input
            class="form-control"
            type="text"
            placeholder="R$ 00.000,00"
            maxlength="17"
            required
            appShowErrorMessages
            requiredMessage="O campo Valor solicitado é obrigatório"
            formControlName="valorSolicitado"
            name="valorSolicitado"
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appMoedaValidator
            appOnlyNumberRestrictive
            [valorMinimo]="valorMinimoParaSolicitar"
            (blur)="fillTabelas()">
        </div>
      </div>
      <div class="destak" *ngIf="proposta.contratoRepique">
        <div class="form-group">
          <span class="icon divida-contrato"></span>
          <div class="inputs">
            <div style="display: inline-flex">
              <label for="tabela">Valor da Dívida Corrigido</label>
              <div style="margin-top: -3px">
                <saiba-mais
                  [isPopoverOnHover]="true"
                  [isPositionStatic]="true"
                  [isSmall]="true"
                  [texto]="'Valor a ser quitado do contrato anterior.'">
                </saiba-mais>
              </div>
            </div>
            <input disabled [value]="valorDivida| currency:'BRL':'symbol':'1.2-2'">
          </div>
        </div>
        <div class="form-group">
          <span class="icon credito"></span>
          <div class="inputs">
            <div style="display: inline-flex">
              <label for="tabela">Valor Liberado</label>
              <div style="margin-top: -3px">
                <saiba-mais
                  [isPopoverOnHover]="true"
                  [isPositionStatic]="true"
                  [isSmall]="true"
                  [texto]="'Valor que o cliente irá receber após quitação do contrato anterior.'">
                </saiba-mais>
              </div>
            </div>
            <input disabled [value]="valorLiberado | currency:'BRL':'symbol':'1.2-2'">
          </div>
        </div>
      </div>
      <div class="form-group">
        <span class="icon cdc-loja"></span>
        <div class="inputs" [formGroup]="principalForm">
          <div style="display: inline-flex">
            <label for="tabela">Tabela</label>
            <div style="margin-top: -3px">
              <saiba-mais
                [isPopoverOnHover]="true"
                [isPositionStatic]="true"
                [isSmall]="true"
                [texto]="'Informe a tabela de juros disponível para o lojista.'">
              </saiba-mais>
            </div>
          </div>
          <select
            class="form-control"
            appShowErrorMessages
            requiredMessage="O campo tabela é obrigatório"
            formControlName="tabela"
            name="tabela">
            <option value="" selected hidden>Selecione...</option>
            <option *ngFor="let tabela of tabelas" value="{{ tabela.id }}">{{ tabela.descricao }}</option>
          </select>
        </div>
      </div>


    </div>
  </form>
  <form class="forms">
    <div class="row">
      <div class="row info-container white-box">

        <div class="form-group">
          <span class="icon pessoas" *ngIf="editing >= 0 || avalistas.length > 0"></span>
          <div class="inputs" *ngIf="editing < 0">
            <app-analise-avalista *ngFor="let avalista of avalistas; index as i" [numero]="i+1" [avalista]="avalista" [classesProfissionais]="classesProfissionais" (edit)="onAvalistaEdit(i)" (remove)="onAvalistaRemove(i)"></app-analise-avalista>
          </div>
          <div class="inputs" *ngIf="editing >= 0" [formGroup]="avalistaForm">
            <label for="cnpjAvalista">Avalista {{ editing + 1 }}</label>

            <input
              class="form-control"
              type="text"
              placeholder="CPF"
              required
              mask-number
              [mask]="'999.999.999-99'"
              inputmode="numeric"
              appCpfValidator
              appShowErrorMessages
              requiredMessage="O campo CPF é obrigatório"
              formControlName="cpf"
              id="cnpjAvalista"
              (blur)="onCpfChangeAvalista()">

            <app-input-date
              required
              requiredMessage="O campo Data de Nascimento é obrigatório"
              placeholder="'Data de nascimento'"
              formControlName="dataNascimento"></app-input-date>

            <select
              class="form-control"
              required
              appShowErrorMessages
              requiredMessage="O campo Classe Profissional é obrigatório"
              formControlName="classeProfissional">
              <option value="" selected hidden>Classe profissional...</option>
              <option *ngFor="let classe of classesProfissionais" value="{{ classe.id }}">{{ classe.descricao }}</option>
            </select>

            <input
              class="form-control"
              type="text"
              placeholder="Renda"
              required
              maxlength="17"
              appShowErrorMessages
              requiredMessage="O campo Renda é obrigatório"
              formControlName="renda"
              mask-money
              inputmode="numeric"
              [prefix]="'R$'"
              appMoedaValidator
              appOnlyNumberRestrictive
              valorMinimo=0>

            <select
              class="form-control"
              required
              appShowErrorMessages
              requiredMessage="O campo Grau de parentesco é obrigatório"
              formControlName="grauParentesco">
              <option value="" selected hidden>Relação com o cliente</option>
              <option value="1">Cônjuge</option>
              <option value="2">Pai / Mãe</option>
              <option value="3">Irmã(o)</option>
              <option value="4">Filho / Filha</option>
              <option value="0">Outros</option>
            </select>


            <div class="mt15 centered">
              <button class="bt-go btn btn-border"
                      (click)="cancelarAvalista()">
                Cancelar
              </button>

              <button class="bt-go btn btn-border-orange"
                      (click)="salvarAvalista()"
                      [disabled]="avalistaForm.invalid">
                Salvar Avalista
              </button>

            </div>
          </div>
        </div>
        <div class="mt15 centered" *ngIf="avalistas.length < 3 && editing < 0">
          <button class="btn btn-border-orange" (click)="addAvalista()">Adicionar Avalista {{ avalistas.length + 1 }}</button>
        </div>
      </div>
    </div>
  </form>
</div>

  <app-botao-navegacao
    (previous)="onClickPrevious()"
    (next)="onClickNext()"
    [previousShow]="true"
    [nextShow]="true"
    [nextEnabled]="formValid"
    [nextLabel]="simulacao?'Continuar':'Simular'"
  ></app-botao-navegacao>

<app-new-modal-message
  #dadosAnaliseModal
  (hiddenModalSubject)="handleModalHide($event)"
  [showFecharBtn]="false"
></app-new-modal-message>
